import React from 'react';
import styles from './Loading.module.css';

export const Loading: React.FC = () => {
  return (
    <div className={styles.loadingContainer}>
      <img
        src="/gif/loading_fin.gif"
        alt="Loading..."
        className={styles.loadingGif}
      />
    </div>
  );
};
